<template>
  <div v-if="to" class="tilewrapper">
    <router-link :to="to" :class="['tile', 'd-block', background]">
      <h2 :class="textcolor">{{ title|puntuado }}</h2>
      <p :class="textcolor">{{ subtitle }}</p>
    </router-link>
  </div>
  <div v-else class="tilewrapper">
    <div :class="['tile', background]">
      <h2 :class="textcolor">{{ title|puntuado }}</h2>
      <p :class="textcolor">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tile',
  props: {
    to: {
      default: null
    },
    title: {
      default: ''
    },
    subtitle: {
      default: ''
    },
    subtitle2: {
      default: ''
    },
    color: {
      default: 'azul'
    }
  },
  data() {
    return {
      textcolor: 'text-white'
    }
  },
  computed: {
    background() {
      return 'bg-' + this.color;
    }
  }
}
</script>

<style>
.tilewrapper {
  margin-bottom: 10px;
}
.tile {
  padding: 0;
  text-decoration: none!important;
}
.tile > p {
  margin: 0;
  text-align: right;
  font-size: 1.3rem;
  background-color: rgba(255, 255, 255, 0.200)!important;
  background-blend-mode: screen!important;
  padding: 2px 10px 4px 10px;
}
.tile > h2 {
  margin-top: 0;
  text-align: right;
  font-size: 2.7rem;
  padding: 10px 10px 7px 10px;
}

@media screen and (max-width: 412px) {
  .tile > h2 {
    font-size: 2rem;
    padding: 7px;
  }
  .tile > p {
    font-size: 1.2rem;
  }
}
</style>


